export const CUSTOMER_ROUTES = {
  list: '/staff/customers',
  // Static segment, declared before the dynamic `:id` sibling. React Router v7
  // ranks static above dynamic regardless of order, but keeping them adjacent
  // makes the pairing obvious to the next reader.
  create: '/staff/customers/new',
  detail: '/staff/customers/:id',
  corporateNew: '/staff/customers/corporate/new',
  corporateDetail: '/staff/customers/corporate/:uen',
} as const;
